var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLandmark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.609 19.5a.5.5 0 0 1 .09.992l-.09.008H3.39a.5.5 0 0 1-.09-.992l.09-.008h17.22ZM4.957 12.283a.5.5 0 0 1 .491.41l.009.09v4.695a.5.5 0 0 1-.992.09l-.008-.09v-4.695a.5.5 0 0 1 .5-.5Zm4.695 0a.5.5 0 0 1 .492.41l.008.09v4.695a.5.5 0 0 1-.992.09l-.008-.09v-4.695a.5.5 0 0 1 .5-.5Zm4.696 0a.5.5 0 0 1 .492.41l.008.09v4.695a.5.5 0 0 1-.992.09l-.008-.09v-4.695a.5.5 0 0 1 .5-.5Zm4.695 0a.5.5 0 0 1 .492.41l.008.09v4.695a.5.5 0 0 1-.991.09l-.009-.09v-4.695a.5.5 0 0 1 .5-.5Zm-7.282-9.33a.5.5 0 0 1 .478 0l8.61 4.695a.5.5 0 0 1 .26.439v2.348a.5.5 0 0 1-.5.5H3.39a.5.5 0 0 1-.5-.5V8.087a.5.5 0 0 1 .26-.439ZM12 3.96 3.891 8.383v1.551h16.217V8.383L12 3.961Zm0 2.56a.783.783 0 1 1 0 1.566.783.783 0 0 1 0-1.565Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLandmark);
export default ForwardRef;